import { render, staticRenderFns } from "./orderLog.vue?vue&type=template&id=5d345d7a&"
import script from "./orderLog.vue?vue&type=script&lang=js&"
export * from "./orderLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports